import { ReactNode } from 'react';
import { Text } from '@components';
import { SEPARATED_LIST_SEPARATOR } from '@types';
import styles from './SeparatedList.module.scss';

export interface SeparatedListProps {
	items: ReactNode[];
	textType?: string;
	separator?: SEPARATED_LIST_SEPARATOR;
}

/* Inline items split by a light vertical divider - "LTL | Rigid | Road" - or a light dot
   ("Pallet · 2 Qty · 100kg"). Strings render as Text,
   any other node (e.g. a TempChip) as-is; empty items are skipped so callers can pass optional
   values straight in. Wraps onto the next line when the row runs out of room. */
export const SeparatedList = (props: SeparatedListProps) => {
	const { items, textType, separator = SEPARATED_LIST_SEPARATOR.LINE } = props;

	return (
		<div className={`${styles.container} ${styles[separator]}`}>
			{items.filter((item) => item !== null && item !== undefined && item !== false && item !== '').map((item, index) => (
				<div key={index} data-testid={'@Ofload-SeparatedList-Item'} className={styles.item}>
					{typeof item === 'string' || typeof item === 'number' ? <Text type={textType}>{item}</Text> : item}
				</div>
			))}
		</div>
	);
}
